import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwalUtil } from 'src/app/services/utils/swal.util';

@Component({
  selector: 'app-modal-add-category',
  templateUrl: './modal-add-category.component.html',
  styleUrls: ['./modal-add-category.component.css']
})
export class ModalAddCategoryComponent implements OnInit {

  loadingCategories: boolean = false
  formCategory: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public categories: any[],
    private dialogRef: MatDialogRef<ModalAddCategoryComponent>,
    private formBuilder: FormBuilder,
    private swalUtil: SwalUtil,
  ) { }

  ngOnInit(): void {
    this.formCategory = this.formBuilder.group({
      category_id: [null]
    });
  }

  onSubmit() {
    const category_id = this.formCategory.get('category_id')?.value;
    if (!category_id) {
      this.swalUtil.popupMessage('Selecione uma categoria para o produto!', 'warning');
      return;
    }
    this.dialogRef.close(category_id);
  }

}
